import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import {
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    colors
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        backgroundColor: colors.grey[200],
        width: "50%",
        height: "50%"
    }
}));

const Create = ({ item, open, closeCreation, createValues, dependencies }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="sm" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Hardware
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>
                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape({
                                code: Yup.string().required('Código é obrigatório'),
                                variant: Yup.string().required('Variante é obrigatória'),
                                name: Yup.string().required('Nome é obrigatório'),
                                platform: Yup.string().required('Plataforma é obrigatória'),
                                manufacturer: Yup.string().required('Frequência Dados é o obrigatória')
                            })
                        }
                        onSubmit={(values, formik) => {
                            createValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>



                                <Grid
                                    container
                                    spacing={2}
                                >

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>

                                        <TextField
                                            error={Boolean(touched.code && errors.code)}
                                            required
                                            fullWidth
                                            label="Código"
                                            margin="normal"
                                            name="code"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.code}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                            InputProps={{ readOnly: false }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.variant && errors.variant)}
                                            fullWidth
                                            required
                                            label="Variante"
                                            margin="normal"
                                            name="variant"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.variant}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.name && errors.name)}
                                            fullWidth
                                            label="Nome"
                                            margin="none"
                                            name="name"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.name}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.platform && errors.platform)}
                                            fullWidth
                                            label="Plataforma"
                                            margin="none"
                                            name="platform"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.platform}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            error={Boolean(touched.manufacturer && errors.manufacturer)}
                                            fullWidth
                                            label="Fabricante"
                                            margin="none"
                                            name="manufacturer"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.manufacturer}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />
                                    </Grid>

                                </Grid>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Cancelar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Create;
